import styled from "@emotion/styled";
import { Collapse } from "@mui/material";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

const topHeaderHeightTablet = 76;
const topHeaderHeightMobile = 48;
const topHeaderHeightDesktop = 84;

export const ContainerDiv = styled.div`
  display: flex;
  height: ${topHeaderHeightDesktop}px;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 0 140px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    padding: 0;
    height: ${topHeaderHeightMobile}px;
  `)}
  ${Styles.BreakpointsUtils.tabletOnly(`
    padding: 0 18;
    height: ${topHeaderHeightTablet}px;
  `)}
`;

export const LogoWrapper = styled.a`
  display: inline-block;
`;

export const Logo = styled.img`
  height: 45px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    padding-left: 18px;
    margin-top: 0;
    height: 24px;
  `)}
`;

export const AccessibilityWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    padding-right: 16px;
  `)}
`;

const icon = `
  color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      color: ${touchpoint.mainColor};
    `
  )}
  cursor: pointer;
  font-size : 45px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    font-size : 24px;
  `)}


`;

export const IconWrapper = styled.a`
  color: ${Styles.Themes.UnipolColors.blueSeven};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      color: ${touchpoint.darkQuaternaryColor};
    `
  )}
  text-decoration: none;

  i {
    ${icon}
   &.icon-Cart{
      content: url("/NextAssets/icons/icon-Cart.svg");  
      height: 22px;
      display: block;
      padding: 0 0.5vw;
      ${Styles.BreakpointsUtils.mobileOnly(`
      height: 15px;
    `)}
    }
      font-size: 36px;
      ${Styles.BreakpointsUtils.mobileOnly(`
        font-size : 24px;
      `)}
    }
  }
`;

export const Collapsible = styled(Collapse)`
  position: absolute;
  top: ${topHeaderHeightDesktop}px;
  left: 0px;
  width: 100%;
  z-index: 100;

  ${Styles.BreakpointsUtils.mobileOnly(`
    top: ${topHeaderHeightMobile}px;
  `)}
`;

export const SubMenu = styled.div`
  background-color: white;
  font-family: Unipol Medium;

  ${Styles.BreakpointsUtils.mobileOnly(`
    padding-bottom: 5px;
    position: relative;
  `)}
`;

const subMenuBackHeight = 54;
export const SubMenuHeader = styled.div`
  background-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      background-color: ${touchpoint.mainColor};
    `
  )}
  display: flex;
  align-items: center;
  height: 45px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    display: none;
  `)}
`;

export const SubMenuHeaderCta = styled.a`
  display: flex;
  height: 100%;
  align-items: center;
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  position: relative;
  width: calc(100% * 5 / 24);
  font-family: Unipol;
  font-size: 16px;
  white-space: nowrap;

  &:hover {
    color: white;
  }

  &:first-of-type {
    margin-left: calc(100% * 2 / 24);
  }
`;

export const SubMenuHeaderIcon = styled.i`
  &.icon-Cerca-agenzia {
    font-size: 30px;
  }

  &.icon-Contatti {
    font-size: 32px;
  }
`;

export const SubMenuDropdown = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: end;
  width: calc(100% * 9 / 24);
  color: white;
  cursor: pointer;
  font-family: Unipol;
  font-size: 12px;
  text-transform: uppercase;
  position: relative;

  &.dropdown-opened {
    color: ${Styles.Themes.UnipolColors.blueOne};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        color: ${touchpoint.mainColor};
      `
    )}
    background-color: white;
    margin: 2px 0 0;
  }
`;

export const DropdownIcon = styled.i`
  font-size: 30px;
  line-height: 1px;
  margin-bottom: 8px;
`;

export const Dropdown = styled(Collapse)`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
`;

export const DropdownUl = styled.ul`
  border-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      border-color: ${touchpoint.mainColor};
    `
  )}
  background: transparent;
  border: 1px solid;
  min-width: 250px;
  text-align: right;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const DropdownLi = styled.li`
  background-color: white;
  list-style: none;
  font-size: 14px;

  &:first-of-type {
    display: inline-block;
    height: 50px;
  }
`;

export const DropdownLink = styled.a`
  color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      color: ${touchpoint.mainColor};
    `
  )}
  display: block;
  background-color: white;
  font-family: Unipol;
  font-weight: 100;
  padding: 15px;
  text-decoration: none;
  line-height: 20px;

  &:hover {
    background-color: ${Styles.Themes.UnipolColors.blueTen};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        background-color: ${touchpoint.whitishColor};
      `
    )}
  }
`;

export const SubMenuContent = styled.div`
  display: flex;
  flex-direction: column;

  &.padding-top {
    padding-top: ${subMenuBackHeight}px;
  }
  ${Styles.BreakpointsUtils.tabletOnly(`
    padding-bottom: 69px;
  `)}
`;

export const SubMenuLinkWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const SubMenuLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-family: Unipol Medium;
  border-bottom: 1.5px solid ${(props) => props.color};
  color: ${(props) => props.color};
  margin-bottom: 8px;
  padding: 0 4px 8px;
  cursor: pointer;
  width: calc(100% * 22 / 24);
`;

export const SubMenuLinkA = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-family: Unipol Medium;
  border-bottom: 1.5px solid ${(props) => props.color};
  color: ${(props) => props.color};
  margin-bottom: 8px;
  padding: 0 4px 8px;
  cursor: pointer;
  width: calc(100% * 22 / 24);
  text-decoration: none;
`;

export const SubMenuIconWrapper = styled.div`
  position: relative;
  background-color: ${(props) => props.color};
  height: 35px;
  width: 35px;
  color: #fff;

  &.bkc_cerchio {
    border-radius: 50%;
  }

  &.bkc_rombo {
    transform: rotate(45deg);
    i {
      transform: rotate(-45deg);
    }
  }
`;

export const SubMenuIcon = styled.i`
  position: absolute;
  font-size: 20px;
  left: 22%;
  top: 21%;
`;

export const SubMenuTitle = styled.div`
  padding-left: 12px;
  color: ${(props) => props.color};
  text-transform: uppercase;
  flex-grow: 1;
`;

export const SubMenuAngleIcon = styled.div`
  font-size: 40px;
`;

export const SubMenuBack = styled.div`
  color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      color: ${touchpoint.mainColor};
    `
  )}
  display: flex;
  align-items: center;
  height: ${subMenuBackHeight}px;
  font-family: Unipol Medium;
  font-size: 16px;
  cursor: pointer;
  margin-left: calc(100% * 2 / 24);
`;

export const SubMenuBackIcon = styled.i`
  font-size: 35px;
`;

export const SubMenuBackText = styled.div`
  text-decoration: underline;
`;

export const SubMenuMiddleLevelTitle = styled.div`
  color: ${(props) => props.color};
  text-transform: uppercase;
  flex-grow: 1;
`;

export const SubMenuLeafLevelLink = styled.a`
  color: ${Styles.Themes.UnipolColors.blueOne};
  border-bottom-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      color: ${touchpoint.mainColor};
      border-bottom-color: ${touchpoint.mainColor};
    `
  )}
  display: flex;
  align-items: center;
  font-size: 14px;
  min-height: 26px;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  border-bottom: 1.5px solid;
  font-family: Unipol Medium;
  margin-bottom: 8px;
  padding: 0 4px 8px;
  width: calc(100% * 22 / 24);
`;

export const SubMenuHeaderMobile = styled.div`
  display: none;

  ${Styles.BreakpointsUtils.mobileOnly(`
    display: flex;
    flex-direction: column;
    margin-top: 54px;
    max-height: 139px;
  `)}
`;

export const SubMenuHeaderMobileLink = styled.a`
  background-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      background-color: ${touchpoint.mainColor};
    `
  )}
  &:hover {
    color: white;
  }
  height: 43px;
  border-bottom: 2px solid #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
  color: #fff;
`;

export const SubMenuHeaderMobileIcon = styled.i`
  font-size: 36px;
  margin: 0 7px 7px calc(100% * 1 / 24);
`;

export const SubMenuDropdownMobile = styled.div`
  background-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      background-color: ${touchpoint.mainColor};
    `
  )}
  display: flex;
  height: 45px;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  color: #fff;
  font-family: Unipol Medium;
  font-size: 16px;
  padding-left: 30px;
  position: relative;

  &.dropdown-opened {
    color: ${Styles.Themes.UnipolColors.blueOne};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        color: ${touchpoint.mainColor};
      `
    )}
    background-color: white;
    margin: 2px 0 0;
  }
`;

export const DropdownIconMobile = styled.i`
  font-size: 30px;
  margin-bottom: 8px;
`;

export const DropdownMobile = styled(Collapse)`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
`;

export const DropdownMobileUl = styled.ul`
  border-color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      border-color: ${touchpoint.mainColor};
    `
  )}
  background: transparent;
  border: 1px solid;
  min-width: 250px;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const DropdownMobileLi = styled.li`
  background-color: white;
  list-style: none;
  font-size: 14px;

  &:first-of-type {
    display: inline-block;
    height: 40px;
  }
`;

export const DropdownMobileLink = styled.a`
  color: ${Styles.Themes.UnipolColors.blueOne};
  ${Styles.TouchpointUtils.touchpointThemeOnly(
    (touchpoint: any) => `
      color: ${touchpoint.mainColor};
    `
  )}
  display: block;
  background-color: white;
  font-family: Unipol;
  font-weight: 100;
  padding: 20px 30px;
  text-decoration: none;
  line-height: 20px;

  &:hover {
    background-color: ${Styles.Themes.UnipolColors.blueTen};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        background-color: ${touchpoint.whitishColor};
      `
    )}
  }
`;
